import { joinParams, handleParams } from '../utils'

export default {
  /**
   * 获取实时房态列表
   * 
   * @param {+} hotel_id 门店id
   * @param {*} room_ids 房间 id 数组，使用逗号分隔多个房间
   * @param {*} room_type_name 房型名
   * @param {*} room_no 房间号
   * @param {*} room_name 房间名
   * @param {*} flag 房间销售状态: 1 销售中 2删除 3下架 4筹建中 5售前展示
   * @param {*} room_state 房间实时状态： 1干净房 2脏房 3已入住 4停用
   * @param {*} calendar_state 房间预定状态： 1可预定 2已预定 3维修 4停用
   * @param {*} is_presale 停售状态：0：正常、1：预售、2：停售；默认is_presale=“0,1”，支持多选查询，使用逗号分隔多个状态
   * @param {+} room_type_type 
   */
  getRoomRealTimeList(params) {
    return this.instance.get('/intelligent_reception/api/v1/room_calendar/realtime', {
      params: handleParams(params)
    })
  },

  /**
   * 获取实时房态筛选条件 及 楼层
   * @param {+} hotel_id 
   * @param {+} room_type_type 
   * @param {+} is_presale  销售状态：0：正常、1：预售、2：停售；如果查询全部，那么可以不传此参；支持多选查询，使用逗号分隔多个状态
   */
  getCalendarFilter(params) {
    return this.instance.get('/intelligent_reception/api/v1/room_calendar/realtime_agg', {
      params: handleParams(params)
    })
  },

  /**
   * 获取房态房价日历 （ 远期房态 ）
   * @param {+} hotel_id 门店id
   * @param {+} start_date 开始日期
   * @param {+} end_date 结束日期
   */
  getRoomCalendar(params) {
    return this.instance.get('/api/v1/room_calendar', {
      params: handleParams(params)
    })
  },

  /**
   * 新增停用单
   * @param {+} beginDate yyyy-MM-dd, * 停用开始时间
   * @param {+} endDate 
   * @param {+} name 停用单联系人名称
   * @param {+} omsAccount oms账户名称
   * @param {*} otaNo 
   * @param {*} stayId 
   * @param {+} phone 停用单联系人电话
   * @param {+} memo 停用单备注
   * @param {+} type 停用单原因type
   * @param {+} roomIds 多个房间id用逗号隔开
   */
  createNewStop(params) {
    return this.instance.post('/api/stop', joinParams(params))
  },

  /**
   * 修复房间状态 置脏置净
   * @param {+} operateCode 置脏1070001 置净1080001
   * @param {+} roomId 
   * @param {+} chainName 
   * @param {+} roomName 
   * @param {+} roomCurrentStat 当前房间状态
   * @param {+} beginDateTime 
   * @param {+} endDateTime 
   */
  updateRoomStatus(params) {
    return this.instance.post('/v1/api/room/updateStatus', joinParams(params))
  },

  /**
   * 获取房型列表
   * @param {+} hotel_id 
   * @param {+} xbed_hotel_id 
   * @param {*} hotel_name 
   * @param {*} room_type_id 
   * @param {*} room_type_ids 
   * @param {*} room_type_name 
   * @param {*} room_type_type 
   * @param {*} room_id 
   * @param {*} room_ids[] 
   * @param {*} xbed_room_id 
   */
  getHotelRoomTypes(params) {
    return this.instance.get('/api/v1/room_types/hotel_room_types', {
      params: handleParams(params)
    })
  },
  
  /**
   * 获取xbed房型列表
   * @param {+} xbed_hotel_id 
   */
  getXbedRoomTypes(params) {
    return this.instance.get('/roomType/ota/getRoomTypeList', {
      params: handleParams(params)
    })
  },

  /**
   * 修改xbed房型缓冲房量
   * @param {+} hotelId xbed门店id
   * @param {*} roomTypeId xbed房型id
   * @param {*} bufferNum 缓冲房量
   * @param {*} operater 操作人
   */
  batchModRoomTypeBuffer(params) {
    return this.instance.post('/roomTypeBuffer/batchMod', {
      roomTypeBufferList: params
    })
  },

  /**
   * 获取门店房间列表
   * @param {+} hotel_id 
   * @param {+} xbed_hotel_id 
   * @param {+} hotel_name 
   * @param {*} room_type_id 
   * @param {*} room_type_ids 
   * @param {*} room_type_name 
   * @param {*} room_type_type 
   * @param {*} room_id 
   * @param {*} room_ids
   * @param {*} xbed_room_id 
   * @param {*} room_name 
   * @param {*} clean_status 
   * @param {*} checkin_status 
   * @param {*} calendars_statuses 
   * @param {*} room_floor 
   * @param {*} room_no_order 
   */
  getHotelRooms(params) {
    return this.instance.get('/api/v1/hotels/hotel_rooms', {
      params: handleParams(params)
    })
  },

  /**
   * TODO:需找江文确定
   * 获取房型价格
   * @param {+} params 
   */
  getRoomTypePrice(params) {
    return this.instance.get('/api/v1/rates/rate_code_list', {
      params: handleParams(params)
    })
  },

  /**
   * TODO:待江文确定
   * 创建/修改房型价格
   * @param {+} params 
   */
  updateRoomTypePrice(params) {
    return this.instance.post('/api/v1/rates/create', params)
  },

  /**
   * xms价格监控
   * @param {*} chainId 
   * @param {*} page 
   * @param {*} size 
   */
  monitorPrice(params) {
    return this.instance.post('/api/noAuth/openElong/getOmsHotelInfo', params)
  },

  /**
   * 批量修改房型价格
   * @param {string} start_date 2020-02-02
   * @param {string} end_date 2020-02-09
   * @param {array} weekday [6, 0, 1 ...]
   * @param {*} operator 操作人
   * @param {array} room_type_batch 
   * @param {*} room_type_id  room_type_batch: [{room_type_id: }]
   * @param {*} rate room_type_batch: [{room_type_id: '1', rate: []}]
   * @param {*} rate_code_id room_type_batch: [{room_type_id: '1', rate: [{rate_code_id: }]}]
   * @param {*} price room_type_batch: [{room_type_id: '1', rate: [price: ]}]
   */
  batchUpdateRoomTypePrice(params) {
    return this.instance.post('/api/v1/rates/create_batch', params)
  }

}


// WEBPACK FOOTER //
// ./src/api/roomType.js